import { controls } from './formParts/AccuralsForFormCompensation'


export const checkErrorsCompensationAccrualsFor = (err: Map<string, string>, formData: FormData) => {
  if (!(
    formData.get(`${controls.single}1`)
    || formData.get(`${controls.single}2`)
    || formData.get(`${controls.class}1`)
    || formData.get(`${controls.class}2`)
  )) {
    err.set('accrualsFor', 'Выберите хотя бы один пункт')
  }
}
